<div class="borderLight" style="display: flex; padding:0px 10px;" *ngIf="!onlyAssigned || hierarchy.emp">
  <ion-card style="width: 350px !important;" class="margin0 padding5">
    <span (click)="masterAction()">{{hierarchy.name}} <span *ngIf="hierarchy.code">- {{hierarchy.code}}</span></span>
   
    <ion-badge color="success" (click)="onClick()" mode="ios" *ngIf="hierarchy.count">{{hierarchy.count}}</ion-badge> 
    <ion-badge color="danger" mode="ios" *ngIf="hierarchy.pendingCount">{{hierarchy.pendingCount}}</ion-badge> 
    <ion-badge style="margin-right: 10px;" color="primary" mode="ios"  *ngIf="hierarchy.emp && hierarchy.emp.user">{{hierarchy.emp.user.name}}
      Ji <ion-icon color="danger" name="close" (click)="removeAm(hierarchy.emp, hierarchy.name)"></ion-icon></ion-badge>
    <!-- <ion-icon name="ellipsis-vertical" (click)="masterAction()"></ion-icon> -->
    <ion-icon name="chevron-down" class="floatRight font2" *ngIf="hierarchy.showChild"
      (click)="hierarchy.showChild=false"></ion-icon>
    <ion-icon name="chevron-forward" class="floatRight font2" *ngIf="!hierarchy.showChild"
      (click)="getCount()"></ion-icon>
  </ion-card>
  <div class="borderLight" *ngIf="hierarchy.showChild">
    <app-hierarchy *ngFor="let child of hierarchy.childList" [onlyAssigned]="onlyAssigned" [emp]="emp"
      [hierarchy]="child"></app-hierarchy>
  </div>
</div>